module.exports = __webpack_public_path__ + "media/Sister-in-law.600d1333.mp3";